<dx-popup
  id="dialog-modification-lot"
  [showTitle]="true"
  [(visible)]="displayDialog"
  [height]="'auto'"
  [width]="'auto'"
  [showCloseButton]="false">

  <div *dxTemplate="let _ of 'title'" class="modif-lot-header">
    <div>
      <yo-icon icon="edit"></yo-icon> <strong> Modifier le lot</strong>
    </div>

    <div class="modif-lot-actions">
      <yo-button [theme]="ButtonThemeEnum.SAVE"
                 iconClass="fas fa-save"
                 (onClick)="updateLot()"
                 [tooltip]="labelSubmit"></yo-button>
      <yo-button [theme]="ButtonThemeEnum.CANCEL"
                 iconClass="fas fa-times"
                 [tooltip]="labelCancel"
                 (onClick)="closeDialog()"></yo-button>
    </div>
  </div>

  @if (lotSelected) {
    <div class="modif-lot-content">
      <div class="modif-lot-left">
        <dx-list
          [dataSource]="dataSource"
          [height]="'212px'"
          selectionMode="single"
          selectAllMode="allPages"
          displayExpr="libelleZoneDeStockage"
          valueExpr="id"
          keyExpr="id"
          [showSelectionControls]="true"
          [searchEnabled]="true"
          [selectedItemKeys]="selectedUdpZdsKeys"
          (onSelectionChanged)="onChangeUdpZds($event)"
          searchExpr="libelleZoneDeStockage"
          searchMode="contains">
          <dxo-search-editor-options
            placeholder="Zone de stockage">
          </dxo-search-editor-options>
        </dx-list>
      </div>

      <div class="modif-lot-right">
        <div class="modif-lot-input-container">
          <div class="modif-lot-inputs">
            <label for="quantite-stock">
              <span class="danger-color">*</span> Quantité
            </label>
            <div class="modif-lot-text-box">
              <dx-text-box
                id="quantite-stock"
                [placeholder]="'Quantité'"
                [(ngModel)]="quantite">
              </dx-text-box>
              <span><strong>{{ lotSelected?.uniteStockageAbreviation }}</strong></span>
            </div>
          </div>

          <div class="modif-lot-inputs">
            <label>
              <span class="danger-color">*</span> PU H.T en UF
            </label>
            <div class="modif-lot-text-box">
              <dx-text-box
                id="prixUnitaireHt"
                [placeholder]="'Prix unitaire Hors Taxe en unité de facturation'"
                [(ngModel)]="prixUnitaireHt">
              </dx-text-box>
              <span><strong>€ / {{ lotSelected.uniteFacturationAbreviation }}</strong></span>
            </div>
          </div>
        </div>

        <div class="modif-lot-input-container">
          <div class="modif-lot-inputs">
            <label>Lot fournisseur</label>
            <dx-text-box
              id="NumeroDeLot"
              [placeholder]="'Numéro de lot'"
              [(ngModel)]="lotArticleFournisseur">
            </dx-text-box>
          </div>
        </div>

        <div class="modif-lot-input-container">
          <div class="modif-lot-inputs">
            <label>
              <span class="danger-color">*</span> Date entrée
            </label>
            <dx-date-box [value]="dateEntree" type="date" placeholder="Date entrée"
                         (onValueChanged)="onChangeDateEntree($event)">
            </dx-date-box>
          </div>
          <div class="modif-lot-inputs">
            <label>
              <span class="danger-color">*</span> DLC / DDM
            </label>
            <dx-date-box [value]="dlc"
                         type="date"
                         placeholder="DLC/DDM"
                         (onValueChanged)="onChangeDlc($event)">
            </dx-date-box>
          </div>
        </div>
      </div>
    </div>
  }
</dx-popup>
